import React from 'react';
import './Header.css';

const Header = () => {
  return (
    <header className="header" id="home">
      <div className="header-inner">
        <span className="header-eyebrow">Cootraespeciales</span>
        <h1 className="header-title">Cotizador de Transporte Especial</h1>
        <p className="header-subtitle">
          Elige origen, destino y pasajeros, y obtén tu cotización al instante.
        </p>
      </div>
    </header>
  );
};

export default Header;
